// extracted by mini-css-extract-plugin
export default {"eventCard":"eventcard_eventCard__HYDcQ","cardDate":"eventcard_cardDate__oit4y","cardBody":"eventcard_cardBody__UufLr"};